// extracted by mini-css-extract-plugin
export default {"marginText":"WizardPanel_marginText__FDMrH"};